




































































































import { Component, Mixins } from 'vue-property-decorator';

import {
  ListingFilter,
  ListingOrderBy,
  TestimonialFilter,
  TestimonialOrderBy,
} from 'client-website-ts-library/filters';
import {
  ListingStatus,
  ListingCategory,
  Profile,
  WebsiteLevel,
} from 'client-website-ts-library/types';

import { View } from 'client-website-ts-library/plugins';
import { API, Config } from 'client-website-ts-library/services';

import Listings from '@/components/Listings.vue';
import ItemCycler from '@/components/Cycler/ItemCycler.vue';
import SideBySide from '@/components/Layout/SideBySide.vue';
import VirtualTour from '@/components/VirtualTour.vue';

@Component({
  components: {
    Listings,
    ItemCycler,
    SideBySide,
    VirtualTour,
  },
})
export default class Home extends Mixins(View) {
  public listingFilterSales = new ListingFilter({
    Statuses: [ListingStatus.Current, ListingStatus.UnderContract],
    Categories: [
      ListingCategory.ResidentialSale,
      ListingCategory.ResidentialLand,
      ListingCategory.Rural,
    ],
    PageSize: 3,
    OrderByStatements: [ListingOrderBy.CreateDateDesc],
  });

  public listingFilterSold = new ListingFilter({
    Statuses: [ListingStatus.Sold],
    Categories: [
      ListingCategory.ResidentialSale,
      ListingCategory.ResidentialLand,
      ListingCategory.Rural,
    ],
    PageSize: 3,
    OrderByStatements: [ListingOrderBy.CreateDateDesc],
  });

  public testimonialFilter: TestimonialFilter | null = null;

  public profile: Profile | null = null;

  mounted() {
    API.Profiles.Get(Config.Website.Settings!.WebsiteId, true).then(
      (profile) => {
        this.profile = profile;
      },
    );

    this.testimonialFilter = new TestimonialFilter({
      SearchLevel: WebsiteLevel.Profile,
      SearchGuid: Config.Website.Settings!.WebsiteId,
      OrderByStatements: [TestimonialOrderBy.CreateDateDesc],
    });
  }
}
